import { t } from '@lingui/core/macro'
import { FormControlLabel, Tooltip } from '@mui/material'
import moment from 'moment'
import { AirbyteSyncStatus, integrationName } from './IntegrationLastSync'
import * as css from './styles'

const tooltipCopy = integration => {
  let date: string
  switch (integration?.status) {
    case AirbyteSyncStatus.PENDING:
    case AirbyteSyncStatus.NORMALIZING:
      return t`Sync in progress`
    default:
      date = integration?.next_fire_time
        ? moment(new Date(integration.next_fire_time)).format('MMM DD YYYY [at] hh:mm A')
        : t`unknown`
      return t`Next sync: ${date}`
  }
}

const ListItem = ({ integration, lastSyncCopy, index }) => (
  <Tooltip
    key={integration?.job_name}
    title={tooltipCopy(integration)}
    disableInteractive
    PopperProps={{
      disablePortal: true,
    }}
  >
    <css.ListItem key={index} status={integration?.status}>
      <img
        src={`https://claravine-public-prod.s3-us-west-2.amazonaws.com/images/${integration.slug}.png`}
        height="42"
        style={{ maxWidth: 42, maxHeight: 42, marginRight: 10 }}
      />
      <div>
        <css.Name>{integrationName(integration.slug)}</css.Name>
        <css.Description>{lastSyncCopy(integration)}</css.Description>
      </div>
    </css.ListItem>
  </Tooltip>
)

const Footer = ({
  showSuccessful,
  setShowSuccessful,
  disableShowSuccessfulCheckbox,
  showFailed,
  setShowFailed,
  disableShowFailedCheckbox,
}) => (
  <css.Footer>
    <FormControlLabel
      label={t`Show successful`}
      control={
        <css.BlueGraySwitch
          onChange={setShowSuccessful}
          name="switch-show-errors"
          size="small"
          checked={showSuccessful}
          disabled={disableShowSuccessfulCheckbox}
        />
      }
      sx={{
        '.MuiFormControlLabel-label': {
          fontSize: '12px',
          color: '#222222',
        },
        '.MuiFormControlLabel-label.Mui-disabled': {
          color: '#7795A1',
        },
        '&.MuiFormControlLabel-root': {
          flex: 1,
        },
      }}
    />
    <FormControlLabel
      label={t`Show failed`}
      control={
        <css.BlueGraySwitch
          onChange={setShowFailed}
          name="switch-show-errors"
          size="small"
          checked={showFailed}
          disabled={disableShowFailedCheckbox}
        />
      }
      sx={{
        '.MuiFormControlLabel-label': {
          fontSize: '12px',
          color: '#222222',
        },
        '.MuiFormControlLabel-label.Mui-disabled': {
          color: '#7795A1',
        },
        '&.MuiFormControlLabel-root': {
          flex: 1,
        },
      }}
    />
  </css.Footer>
)

export const Integrations = ({ children }) => <css.ListContainer>{children}</css.ListContainer>

const List = ({ children }) => <css.List>{children}</css.List>

Integrations.List = List
Integrations.Footer = Footer
Integrations.ListItem = ListItem
